<script>
const qs = require("qs");

export default {
  data: () => ({
    response: [],
    transferResponse: [],
    payment: {
      success: 0,
      cancel: 0,
      amount: 0,
      charges: 0,
      loading: false
    },
    transfer: {
      success: 0,
      cancel: 0,
      amount: 0,
      charges: 0,
      loading: false
    },
    filter: {
      createdAt: {
        start: new Date(2019, 8, 1).toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10)
      },
      period: "day",
      application: null,
      user: null,
      status: null
    },
    groups: [],
    sums: [],
    period: "",
    urlItems: "",
    urlItemsTransfer: ""
  }),
  methods: {
    getStatistic(type = "payment") {
      let self = this;
      let params = {};
      params["_search"] = this.buildSearchQuery(type);

      params["_sums"] =
        type === "payment"
          ? ["p_amount", "p_charges"]
          : ["t_amount", "t_charges"];
      params["_groups"] =
        type === "payment" ? ["p_createdAt"] : ["t_createdAt"];
      params["_sorts"] = {};
      params["_sorts"] =
        type === "payment" ? { p_createdAt: "ASC" } : { t_createdAt: "ASC" };
      if (!this._.isEmpty(this.groups))
        params["_groups"] = params["_groups"].concat(this.groups);
      if (!this._.isEmpty(this.sums))
        params["_sums"] = params["_sums"].concat(this.sums);
      if (!this._.isEmpty(this.period)) params["_period"] = this.period;
      if (type === "payment") {
        this.payment.loading = true;
      } else {
        this.transfer.loading = true;
      }
      return new Promise((resolve, reject) => {
        self.$store
          .dispatch("request", {
            url: type === "payment" ? self.urlItems : self.urlItemsTransfer,
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params);
            }
          })
          .then(response => {
            if (type === "payment") {
              this.response = response.data;
            } else {
              this.transferResponse = response.data;
            }

            if (type === "payment") {
              let filter = self._.filter(response.data, function(o) {
                return o.p_status === "SUCCESS";
              });
              self.payment.amount = self._.sumBy(filter, "total_p_amount");
              self.payment.charges = self._.sumBy(filter, "total_p_charges");
              if (!this._.isEmpty(filter)) {
                self.payment.success = self._.sumBy(filter, function(o) {
                  return parseInt(o.count);
                });
              } else {
                self.payment.success = 0;
              }

              filter = self._.filter(response.data, function(o) {
                return o.p_status === "CANCEL";
              });

              if (!this._.isEmpty(filter))
                self.payment.cancel = self._.sumBy(filter, function(o) {
                  return parseInt(o.count);
                });
              else self.payment.cancel = 0;
              this.payment.loading = false;
            } else {
              let filter = self._.filter(response.data, function(o) {
                return o.t_status === "SUCCESS";
              });
              self.transfer.amount = self._.sumBy(filter, "total_t_amount");
              self.transfer.charges = self._.sumBy(filter, "total_t_charges");
              if (!this._.isEmpty(filter)) {
                self.transfer.success = self._.sumBy(filter, function(o) {
                  return parseInt(o.count);
                });
              } else {
                self.transfer.success = 0;
              }

              filter = self._.filter(response.data, function(o) {
                return o.t_status === "CANCEL";
              });

              if (!this._.isEmpty(filter))
                self.transfer.cancel = self._.sumBy(filter, function(o) {
                  return parseInt(o.count);
                });
              else self.transfer.cancel = 0;
              this.transfer.loading = false;
            }
            resolve(response);
          })
          .catch(err => {
            self.$store.dispatch("setNotification", {
              status: true,
              message: self.$vuetify.lang.t("$vuetify.error_occured")
            });
            if (type === "payment") {
              this.payment.loading = false;
            } else {
              this.transfer.loading = false;
            }

            reject(err);
          });
      });
    },
    _groupBy(key, type = "payment") {
      let result = [];
      let self = this;
      let labels = this._getLabels(key, null, type);
      let filter = [];
      let sum = 0;
      let obj = {};
      let data = type === "payment" ? this.response : this.transferResponse;
      const fieldTotal =
        type === "payment" ? "total_p_amount" : "total_t_amount";
      this._.forEach(labels, label => {
        filter = self._.filter(data, function(o) {
          return o[key] === label;
        });
        sum = self._.sumBy(filter, function(o) {
          return parseInt(o[fieldTotal]);
        });
        obj[key] = label;
        obj[fieldTotal] = sum;
        sum = self._.sumBy(filter, function(o) {
          return parseInt(o.count);
        });
        obj["count"] = sum;
        result.push(obj);
        sum = 0;
        obj = {};
      });
      return result;
    },
    _getLabels(key, datas = null, type = "payment") {
      let result = [];
      let response = type === "payment" ? this.response : this.transferResponse;
      datas = datas ? datas : response;
      this._.forEach(datas, data => {
        result.push(data[key]);
      });
      result = this._.uniq(result);
      return result;
    },
    buildSearchQuery(type = "payment") {
      let query = "";
      let field =
        type === "payment" ? "p_createdAt::lte::" : "t_createdAt::lte::";
      query =
        field +
        this.$moment(this.filter.createdAt.end)
          .endOf("day")
          .format("x");
      field =
        type === "payment" ? ",p_createdAt::gte::" : ",t_createdAt::gte::";
      query +=
        field +
        this.$moment(this.filter.createdAt.start)
          .startOf("day")
          .format("x");

      if (this.filter.application) {
        query +=
          type === "payment"
            ? ",p_applicationId::eq::" + this.filter.application
            : ",t_applicationId::eq::" + this.filter.application;
      }

      if (this.filter.user) {
        query +=
          type === "payment"
            ? ",a_userId::eq::" + this.filter.user
            : ",a_userId::eq::" + this.filter.user;
      }

      if (this.filter.status) {
        query +=
          type === "payment"
            ? ",p_status::eq::" + this.filter.status
            : ",t_status::eq::" + this.filter.status;
      }

      if (this.filter.transaction) {
        query +=
          type === "payment"
            ? ",p_type::eq::" + this.filter.transaction
            : ",t_type::eq::" + this.filter.transaction;
      }

      return query;
    }
  }
};
</script>

<style scoped></style>
